import React from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";
import { Col, Row } from "react-bootstrap";

const UpdateProfile = () => {
  return (
    <AuthLayout>
      <div>
        <h5>Employee</h5>
      </div>
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id="home-tab"
            data-bs-toggle="tab"
            data-bs-target="#home-tab-pane"
            type="button"
            role="tab"
            aria-controls="home-tab-pane"
            aria-selected="true"
          >
            Employee Profile
          </button>
        </li>
        <li className="nav-item bg-white" role="presentation">
          <button
            className="nav-link"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#profile-tab-pane"
            type="button"
            role="tab"
            aria-controls="profile-tab-pane"
            aria-selected="false"
          >
            Document Library
          </button>
        </li>
      </ul>
      <div className="tab-content bg-white p-5" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="home-tab-pane"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <Row>
            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  First Name<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="first_name"
                  placeholder="first name"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">Middle Name</label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="middle_name"
                  placeholder="middle name"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Last Name<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="last_name"
                  placeholder="last name"
                />
              </div>
            </Col>
            <Col md={4} sm={12} className="mt-3">
              <h6>Gender</h6>
              <div className="form-group mb-3 border border-dark p-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="gender"
                  id="gender1"
                />
                <label className="form-check-label px-2" htmlFor="gender1">
                  Internal
                </label>
                {"  "}
                <input
                  className="form-check-input"
                  type="radio"
                  name="gender"
                  id="gender2"
                />
                <label
                  className="form-check-label px-2"
                  htmlFor="flexRadioDefault2"
                >
                  External
                </label>
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Highest Qualification<sup className="text-danger">*</sup>
                </label>
                <select className="form-control form-select border-dark rounded-0">
                  <option selected disabled>
                    Select Highest Qualification
                  </option>
                  <option>Bsc</option>
                  <option>Msc</option>
                </select>
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group mb-3">
                <label className="form-label">
                  Date of Birth <sup className="text-danger">*</sup>
                </label>
                <div className="input-group">
                  <span
                    className="input-group-text border-dark"
                    id="basic-addon1"
                  >
                    <i className="bi bi-calendar-plus"></i>
                  </span>
                  <input
                    type="date"
                    className="form form-control border-dark rounded-0"
                    name="dob"
                  />
                </div>
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Phone:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="phone"
                  placeholder="phone"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Email:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="email"
                  placeholder="email"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Program Type<sup className="text-danger">*</sup>
                </label>
                <select className="form-control form-select border-dark rounded-0">
                  <option selected disabled>
                    Select Program Type
                  </option>
                  <option>Bsc</option>
                  <option>Msc</option>
                </select>
              </div>
            </Col>

            <Col md={12} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Address:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="address"
                  placeholder="address"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Province:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="province"
                  placeholder="province"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Town/City<sup className="text-danger">*</sup>
                </label>
                <select
                  className="form-control form-select border-dark rounded-0"
                  name="city"
                >
                  <option selected disabled>
                    Select Town
                  </option>
                  <option>Ontario</option>
                  <option>Fege</option>
                </select>
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Postal Code:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="postal code"
                  placeholder="postal code"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <h6>Account Status</h6>
              <div className="form-group mb-3 border border-dark p-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="status"
                  id="status"
                />
                <label
                  className="form-check-label px-2 text-success"
                  htmlFor="gender1"
                >
                  Active
                </label>
                {"  "}
                <input
                  className="form-check-input"
                  type="radio"
                  name="status"
                  id="status2"
                />
                <label
                  className="form-check-label px-2 text-danger"
                  htmlFor="flexRadioDefault2"
                >
                  InActive
                </label>
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Incoporation Name:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="incop_name"
                  placeholder="incoporation name"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Incoporation Address:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="incop_add"
                  placeholder="incoporation address"
                />
              </div>
            </Col>

            <Col md={12} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Notes:<sup className="text-danger">*</sup>
                </label>
                <textarea className="form-control" name="notes"></textarea>
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  HST Number:<sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control border-dark rounded-0"
                  name="hst"
                  placeholder="HST Number"
                />
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Assign Admin<sup className="text-danger">*</sup>
                </label>
                <select
                  className="form-control form-select border-dark rounded-0"
                  name="city"
                >
                  <option selected disabled>
                    Assign Admin
                  </option>
                  <option>Ontario</option>
                  <option>Fege</option>
                </select>
              </div>
            </Col>

            <Col md={4} sm={12} className="mt-3">
              <div className="form-group">
                <label className="form-label">
                  Assign Director<sup className="text-danger">*</sup>
                </label>
                <select
                  className="form-control form-select border-dark rounded-0"
                  name="city"
                >
                  <option selected disabled>
                    Assign Director
                  </option>
                  <option>Ontario</option>
                  <option>Fege</option>
                </select>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="tab-pane fade"
          id="profile-tab-pane"
          role="tabpanel"
          aria-labelledby="profile-tab"
        >
          ...
        </div>
        <div
          className="tab-pane fade"
          id="contact-tab-pane"
          role="tabpanel"
          aria-labelledby="contact-tab"
        >
          ...
        </div>
        <div
          className="tab-pane fade"
          id="disabled-tab-pane"
          role="tabpanel"
          aria-labelledby="disabled-tab"
        >
          ...
        </div>
      </div>
    </AuthLayout>
  );
};

export default UpdateProfile;
